import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { LoginProvider } from '../../providers/login/login';

@IonicPage()
@Component({
  selector: 'page-update-profile',
  templateUrl: 'update-profile-form.html',
})
export class UpdateProfileFormPage {
 
	page_title="";
	details = [];
  fields :any;
  updateData ={};

  constructor(public navCtrl: NavController,
    private translate: TranslateService, 
    public navParams: NavParams, 
    private loginProvider: LoginProvider) {
  	
  	this.details = navParams.get("details");	
    this.loginProvider.getUserUpdateForm().then(val => {
      console.log('login proivider called==>',val)
      this.fields=val.data[0].fields
      console.log("fields array======>",this.fields);
      
    });
  
  }
   
  ionViewDidLoad() {
    console.log('ionViewDidLoad updateProfileFormPage');
  }
  onSubmit(){
    console.log(this.updateData)
  
  }
}



// WEBPACK FOOTER //
// ./src/pages/update-profile/update-profile-form.ts